export default "__VITE_ASSET__dfca8f22__"